import { type DefaultOptions, QueryClient } from "@tanstack/react-query";

const V2_QUERY_DEFAULTS = {
  staleTime: 30_000,
  retry: 1,
  refetchOnWindowFocus: false,
} as const;

export function createQueryClient(overrides?: DefaultOptions): QueryClient {
  return new QueryClient({
    defaultOptions: {
      ...overrides,
      queries: { ...V2_QUERY_DEFAULTS, ...overrides?.queries },
    },
  });
}

/** App-wide singleton; tests build their own via createQueryClient/renderV2. */
export const queryClient = createQueryClient();
